import "./FormLayout.css";

export default function FormLayout({ children, type = "default" }) {
    if (type === "sidebar") {
        return (
            <div className="form-layout with-sidebar">
                {children}
            </div>
        );
    }

    // Default layout
    return (
        <div className="form-layout">
            {children}
        </div>
    );
}